import {useFlux} from '@nlabs/arkhamjs-utils-react';
import {useEffect} from 'react';

import {loadChicagoWeather} from '../actions/weatherActions';
import type {WeatherSnapshot} from '@chicago-sentinel/contracts/weather';

const weatherRequests = new Map<string, Promise<WeatherSnapshot>>();

export const SiteLoadWeather = () => {
  const flux = useFlux();
  const hostname = window.location.hostname;

  useEffect(() => {
    let active = true;
    const existingRequest = weatherRequests.get(hostname);
    const request = existingRequest ?? loadChicagoWeather(flux, hostname);
    if(!existingRequest) weatherRequests.set(hostname, request);

    void request.then((weather) => {
      if(active) void flux.dispatch({status: 'live', type: 'WEATHER_REPLACE', weather});
    }).catch(() => {
      weatherRequests.delete(hostname);
      if(active) void flux.dispatch({status: 'error', type: 'WEATHER_REPLACE'});
    });

    return () => { active = false; };
  }, [flux, hostname]);

  return null;
};
